import React from 'react';
import { observer } from 'mobx-react';
import { get as _get } from 'lodash';

import MailIcon from 'assets/icons/mail.svg';
import ContactIcon from 'assets/icons/contact.svg';
import PharmacyIcon from 'assets/icons/pharmacy-active.svg';

import './contact-style.scss';

const ContactView = ({
  activeTechnician,
}) => {
  if (!activeTechnician) return null;
  const user = _get(activeTechnician, 'ptUser.user', {});
  const pharmacies = _get(activeTechnician, 'pharmacies', []);

  return (
    <div className='c-TechnicianContact'>
      <div className='data'>
        <div className='data-row'>
          <div className='name'>
            <img alt='phone' src={ContactIcon} className='icon'/>
            <div className='text'>Phone</div>
          </div>
          <div className='value'>
            {user.phoneNumber || 'N/A'}
          </div>
        </div>
        <div className='data-row'>
          <div className='name'>
            <img alt='email' src={MailIcon} className='icon'/>
            <div className='text'>Email</div>
          </div>
          <div className='value'>
            {user.email || 'N/A'}
          </div>
        </div>
        {
          !!pharmacies.length &&
          <div className='data-row'>
            <div className='name'>
              <img alt='pharmacy' src={PharmacyIcon} className='icon'/>
              <div className='text'>Pharmacies</div>
            </div>
            <div className='value-column'>
              {
                pharmacies.map((pharmacy) => (
                  <div key={pharmacy.id} className='value'>
                    {
                      pharmacy.name
                    }
                  </div>
                ))
              }
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default observer(ContactView);
